export const BET_TYPES = {
  OPEN: 'OPEN',
  FACING_OPEN_CALL: 'FACING_OPEN_CALL',
  FACING_OPEN_3BET: 'FACING_OPEN_3BET',
  FACING_3BET_CALL: 'FACING_3BET_CALL',
  FACING_3BET_4BET: 'FACING_3BET_4BET',
  FACING_3BET_4BET: 'FACING_3BET_4BET',
  SB_LIMP: 'LIMP',
  SQUEEZE_4BET: 'SQUEEZE_4BET'
};